import { render } from "./LineCallback.vue?vue&type=template&id=578347b0"
import script from "./LineCallback.vue?vue&type=script&lang=ts"
export * from "./LineCallback.vue?vue&type=script&lang=ts"
script.render = render

export default script